import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { media } from "../../data/media";
import type { DesignProject } from "../../types/design";
type DesignCardProps = {
  project: DesignProject;
};
export function DesignCard({
  project
}: DesignCardProps) {
  const reduceMotion = useReducedMotion();
  const cover = (media as Record<string, string>)[project.plate] ?? media.archivePlate;
  return <motion.a href={project.href} target="_blank" rel="noreferrer" data-cursor="Open" whileHover={reduceMotion ? undefined : {
    y: -8
  }} transition={{
    duration: 0.4,
    ease: [0.16, 1, 0.3, 1]
  }} className="group block rounded-[18px] bg-[#eeeeeb] p-3 text-left shadow-[0_30px_70px_-30px_rgba(0,0,0,0.85)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#54f6c6] focus-visible:ring-offset-2 focus-visible:ring-offset-[#050808] md:p-4" data-id="element-449" data-mp="2aa4mk9gkgtng">
      <div className="relative aspect-[4/3] overflow-hidden rounded-[10px] bg-[#0c100f]" data-id="element-450" data-mp="1ml27n9dbhewn">
        <img src={cover} alt="" aria-hidden="true" className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]" loading="lazy" data-id="element-451" data-mp="1tlqynajep0qg" />
        <span className="absolute left-3 top-3 rounded-full bg-black/50 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white/85 backdrop-blur-sm" data-id="element-452" data-mp="27e6vtupmm4jg">
          Case {project.index}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-black/50 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white/75 backdrop-blur-sm" data-id="element-453" data-mp="1er2xu9oyaqh6">
          Figma
        </span>
        <span aria-hidden="true" className="absolute bottom-3 right-3 flex h-9 items-center gap-2 rounded-full bg-[#050808]/75 px-3.5 font-mono text-[10px] uppercase tracking-[0.14em] text-white opacity-0 backdrop-blur-sm transition-opacity duration-300 group-hover:opacity-100" data-id="element-454" data-mp="1oqboasklxmys">
          Open <ArrowUpRight className="h-3 w-3" data-id="element-455" data-mp="2adxcm0t5ae1x" />
        </span>
      </div>

      <h3 className="mt-6 px-1 text-[clamp(1.15rem,1.5vw,1.6rem)] font-semibold leading-[1.05] tracking-[-0.045em] text-[#0a0e0d]" data-id="element-456" data-mp="25fvrlac5s4nt">
        {project.title}
      </h3>

      <div className="mt-5 flex flex-wrap gap-x-7 gap-y-4 px-1 pb-2" data-id="element-457" data-mp="2ff4ks0z79f94">
        {project.tags.map(tag => <span key={tag} className="block" data-id="element-458" data-mp="1roh872eca1g8">
            <span aria-hidden="true" className="mb-2 block h-3 w-px bg-[#0a0e0d]/45" data-id="element-459" data-mp="1rpjxj5w0jvu1" />
            <span className="block font-mono text-[11px] uppercase tracking-[0.12em] text-[#0a0e0d]/75" data-id="element-460" data-mp="1mrqv8nxtzlz1">{tag}</span>
          </span>)}
      </div>
    </motion.a>;
}